module.exports = __webpack_public_path__ + "img/banner_league.31356d3.jpg";